<template>
  <div>

    <Head title="Accessory Groups" />

    <div class="flex items-center mb-8">
      <h1 class="text-3xl font-bold">Accessory Groups Management</h1>
      <span class="text-xs mx-2 rounded-full p-2 bg-gray-200">{{ groups.length }}</span>
    </div>

    <div class="flex items-center justify-between mb-6">
      <div class="flex items-center gap-4 flex-1">
        <input v-model="form.search" type="text" placeholder="Search groups..." class="form-input w-full max-w-md"
          @input="searchDebounced" />
        <select v-model="form.system" class="form-select max-w-xs" @change="filter">
          <option :value="null">All Systems</option>
          <option v-for="system in systems" :key="system.id" :value="system.id">
            {{ system.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="bg-white shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Name</th>
            <th class="pb-4 pt-6 px-6">Description</th>
            <th class="pb-4 pt-6 px-6">System</th>
            <th class="pb-4 pt-6 px-6">Accessories</th>
            <th class="pb-4 pt-6 px-6">Status</th>
            <th class="pb-4 pt-6 px-6">Series</th>
            <th class="pb-4 pt-6 px-6"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="group in groups" :key="group.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 font-medium text-blue-600"
                :href="`/accessory-groups/${group.id}`">
              {{ group.name }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/accessory-groups/${group.id}`" tabindex="-1">
              {{ group.description || '-' }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/accessory-groups/${group.id}`" tabindex="-1">
              {{ group.system || 'All Systems' }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/accessory-groups/${group.id}`" tabindex="-1">
              <span class="bg-gray-200 text-blue-800 px-2 py-1 rounded-full text-sm">
                {{ group.accessories_count }}
              </span>
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/accessory-groups/${group.id}`" tabindex="-1">
              <span v-if="group.is_active" class="text-green-600 font-medium">
                Active
              </span>
              <span v-else class="text-gray-400">
                Inactive
              </span>
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/accessory-groups/${group.id}`" tabindex="-1">
              <span class="bg-gray-200 text-blue-800 px-2 py-1 rounded text-xs font-medium">
                {{ group.name }}
              </span>
              </Link>
            </td>
            <td class="w-px border-t">
              <div class="flex">
                <Link class="flex items-center px-2" :href="`/accessory-groups/${group.id}/edit`" tabindex="-1">
                <icon name="edit" class="block w-4 h-4 fill-gray-400" />
                </Link>
              </div>
            </td>
          </tr>
          <tr v-if="groups.length === 0">
            <td class="px-6 py-4 border-t" colspan="7">No groups found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- No pagination needed for dynamic groups -->
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  components: {
    Head,
    Icon,
    Link,
  },
  layout: Layout,
  props: {
    groups: Array,
    systems: Array,
    filters: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        system: this.filters.system,
      },
    }
  },
  methods: {
    filter() {
      this.$inertia.get('/accessory-groups', pickBy(this.form), {
        preserveState: true,
        replace: true,
      })
    },
    searchDebounced: throttle(function () {
      this.filter()
    }, 300),
  },
}
</script>